<template>
  <div>
    <PaxWidget
      :paxObject="params.paxObject"
      :minPax="params.minPax"
      :maxPax="params.maxPax"
      :kalkPax="params.kalkPax"
      :forecastPax="params.forecastPax"
      :durchfuehrbareMinPax="params.durchfuehrbareMinPax"
      :id="params.id"
    ></PaxWidget>
  </div>
</template>

<script>
import PaxWidget from '@/components/produkte/reisetermine/pax-widget.vue';

export default {
  components: {
    PaxWidget,
  },
};
</script>
<style></style>
